import { gql } from '@apollo/client';

export const GET_ALL_DROPDOWNS = gql`
  query getAllDropdowns($first: Int!, $offset: Int!, $filter: DropdownFilter!) {
    allDropdowns(filter: $filter, offset: $offset, first: $first) {
      nodes {
        ddId
        ddLabel
        ddValue
        ddType
      }
    }
  }
`;

export type DropdownNode = {
  ddId: string;
  ddLabel: string;
  ddValue: string;
  ddType: 'GENRE' | 'AGE_RATING' | 'IMAGE_TYPE';
};

export type GetAllDropdownsData = {
  allDropdowns: {
    nodes: DropdownNode[];
  };
};

export type DropdownFilter = {
  ddType?: {
    equalTo?: string;
  };
  ddValue?: {
    in?: string[];
    notIn?: string[];
  };
  ddDeletedAt?: {
    isNull?: boolean;
  };
};

export type GetAllDropdownsVariables = {
  first: number;
  offset: number;
  filter: DropdownFilter;
};
